export default {
  'm': {
    'EnterID': 'BuzzCast ID इनपुट पर क्लिक करें',
    'select-specifications': 'रिचार्ज विनिर्देशों का चयन करने के लिए क्लिक करें',
    'check-account': 'रिचार्ज अकाउंट चेक करें',
    'whatID': 'BuzzCast ID क्या है ？',
    'getID': 'BuzzCast ID इनपुट करें',
    'maskgetID': ' BuzzCast ID इनपुट करें',
    'toastTips-format-error': 'गलत इनपुट प्रारूप',
    'toastTips-no-exist': 'यह ID मौजूद नहीं है',
    'toastTipsPlease': 'कृपया पहले से रिचार्ज अकाउंट चेक करें',
    'common-problem': 'सामान्य समस्या',
    'transaction-succeeded': 'सौदा सफल है',
    'transaction-failed': 'सौदा विफल है',
    'transaction-cancel': 'सौदा का खात्मा किया गया है',
    'whether-account': '1. रिचार्ज के बाद मैं कैसे जांचें कि क्या पैसा प्राप्त किया है या नहीं?',
    'answer-whether-account': 'रिचार्ज के बाद, आप हीरे की जांच करने के लिए app में [मेरा] - [वॉलेट] पर वापस जा सकते हैं',
    'no-account': '2.रिचार्ज के बाद अगर पैसा प्राप्त नहीं किया तो कैसे करें?',
    'answer-no-account': 'कृपया app में अपना प्रश्न [संदेश] - [आधिकारिक संदेश] - [प्रतिक्रिया और मदद] प्रस्तुत करें और निम्नलिखित जानकारी प्रदान करें। हमारी ग्राहक सेवा आपकी मदद करे।',
    'recharge-money': '1. रिचार्ज राशि और खाता ID',
    'recharge-time': '2. रिचार्ज का समय और तारीख',
    'recharge-shot': '3. सफल भुगतान के स्क्रीनशॉट',
    'recharge-wrong': '3.गलत रिचार्ज का अकाउंट और गलत रिचार्ज की राशि तो कैसे करें',
    'answer-recharge-wrong': 'भुगतान पासवर्ड दर्ज करने से पहले, खरीदने से पहले रिचार्ज अकाउंट ID और रिचार्ज राशि की जानकारी सावधानी से पुष्टि करें। गलत रिचार्ज की राशि वापस नहीं की जा सकती। गलत चार्ज खाते के लिए, आप वास्तविक रिचार्ज के ID उपयोगकर्ता से संपर्क करने की कोशिश करें और दूसरे पक्ष से बातचीत कर सकते हैं कि क्या वे रिचार्ज के लिए आपको इनाम देने के लिए तैयार हैं।',
    'refund': '4.वापसी',
    'answer-refund': '"माफ़ कीजिये!BuzzCast वर्तमान में किसी भी रूप की वापसी का समर्थन नहीं करता।"',
    'buy-enter-link': '"आप हीरे खरीदने के लिए लिंक के माध्यम से कर सकते हैं，<a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> इस लिंक को कॉपी करें , मोबाइल ब्राउज़र में खोलें और खरीद पृष्ठ दर्ज करें। खाता संख्या की जांच करने के बाद उपयुक्त विनिर्देशों का चयन करें और भुगतान करने के लिए उपयुक्त भुगतान विधि का उपयोग करें। कम कीमत और उच्च डिस्काउंट।"',
    'buy-notice-a': 'नोट: <a>{msg}</a> ही BuzzCast की एकमात्र आधिकारिक हीरे खरीदमे का वेबसाइट है',
    'replace': 'बदलें',
    'sureBtn': 'निर्धारित',
    'pay-style': 'भुगतान विधि चुनें',
    'goBack': 'वापस होम पेज पर',
    'toastTips': 'BuzzCast ID इनपुट करें',
    'rechargeFAQ_title': 'सामान्य समस्या',
    'PayStatusSuccess_title': 'सौदा सफल है',
    'PayStatusFail_title': 'सौदा विफल है',
    'PayStatusCancel_title': 'सौदा का खात्मा किया गया है',
    'Diamonds_title': '{msg} आधिकारिक डायमंड रिचार्ज वेबसाइट',
    'buy-notice': 'नोट pay.buzzcast.info BuzzCast की एकमात्र आधिकारिक हीरा खरीदने वाली वेबसाइट है, कृपया [संदेश] - [आधिकारिक समाचार] - [प्रतिक्रिया और सहायता] पर जाएं।',
    'RechargeHelp_title': 'रिचार्ज मदद',
    'openAPP': 'ओपन BuzzCast एपीपी',
    'buy-diamonds-tit': 'हीरा सेवाएं खरीदें',
    'description': 'BuzzCast एकल आधिकारिक डायमंड रिचार्ज वेबसाइट है, BuzzCast एक अंतर्राष्ट्रीय सामाजिक सॉफ्टवेयर है जिसका उपयोग दुनिया भर के 150 से अधिक देशों और क्षेत्रों में किया जाता है',
    'keywords': 'BuzzCast रिचार्ज, BuzzCast डायमंड रिचार्ज, BuzzCast आधिकारिक रिचार्ज, BuzzCast आधिकारिक रिचार्ज वेबसाइट',
    'payforType': '  रिचार्ज विधि',
    'trueText': ' निर्धारित',
    'falseText': ' रद्द करना',
    'alertShowTxt1': ' क्या आप',
    'alertShowTxt3': ' हीरे को रिचार्ज करने के लिए',
    'alertShowTxt5': ' का उपयोग करना सुनिश्चित करते हैं?',
    'EnterIDTip': '{msg} त्वरित रिचार्ज',
    'scanLogin': ' खाता गोपनीयता और सुरक्षा के लिए, कृपया लॉग इन करने के लिए कोड को स्कैन करें',
    'scanTip': ' टिप: लॉग इन करने के लिए कोड को स्कैन करने के लिए BuzzCast "पर्सनल सेंटर / डायनामिक्स" के ऊपरी दाएं कोने पर "स्कैन" पर क्लिक करें। साथ ही, यह QR कोड स्क्रीनशॉट की पहचान करके लॉग इन करने का समर्थन करता है',
    'scanVersion': ' कृपया BuzzCast को %s संस्करण में अपग्रेड करें और लॉग इन करने के लिए कोड को स्कैन करें',
    'delAccount': ' खाता हटाना',
    'logout': ' छोड़ना',
    'submit': 'प्रस्तुत करना',
    'email_place_holder': 'अपना ईमेल पता दर्ज करें',
    'contact_email': 'ई - मेल से संपर्क करे',
    'provide_email': 'भुगतान सूचना प्राप्त करने के लिए कृपया अपना ईमेल पता प्रदान करें',
    'email_address': 'ईमेल पता',
    'sel_country_area': 'देश या क्षेत्र का चयन करें',
    'search_for': 'एक खोज खोजें',
    'login': 'लॉग इन करें',
    'scan_login': 'स्कैनिंग कोड लॉगिन',
    'account_password_error': 'फोन नंबर या पासवर्ड गलत है',
    'user_frozen': 'उपयोगकर्ता को फ्रीज कर दिया गया है',
    'account_no_reg': 'खाता पंजीकृत नहीं है',
    'login_no': 'आपने लॉग - इन नहीं किया',
    'login_after_recharge': 'लॉग इन करने के बाद आप रिचार्ज कर सकते हैं',
    'scan_login_lesson': 'स्कैनिंग कोड लॉगिन का ट्यूटोरियल',
    'scan_login_desc': 'रिचार्ज वेबसाइट को लॉगिन करने के लिए कोड लॉगिन को स्कैन करने की विधि जल्दी और सुरक्षित रूप से महसूस कर सकती है। निम्नलिखित दो विधियाँ क्रमशः लॉगिन करने के लिए कोड को स्कैन करने का तरीका बताएंगी।',
    'scan_login_a_title': 'QR कोड के स्क्रीनशॉट को पहचानकर लॉग इन करें',
    'scan_login_a_p1': '1. यह एकल डिवाइस के परिदृश्य का उपयोग करने के लिए अधिक उपयुक्त है। उपयोगकर्ता रिचार्ज वेबसाइट के लॉगिन पेज में प्रवेश करता है, "स्कैन कोड टू लॉगिन" का चयन करने के लिए क्लिक करता है, और लॉगिन क्यूआर कोड के साथ पृष्ठ का स्क्रीनशॉट प्रदर्शित होता है, और एल्बम को बचाता है। (स्क्रीनशॉट फ़ंक्शन विभिन्न उपकरणों के लिए थोड़ा अलग है, आप अपने द्वारा स्क्रीनशॉट फ़ंक्शन के संचालन निर्देशों की खोज कर सकते हैं)',
    'scan_login_a_p2': '2. "पर्सनल सेंटर" या "डायनामिक" फ़ंक्शन मॉड्यूल के माध्यम से BuzzCast APP खोलें, कोड स्कैनिंग फ़ंक्शन मॉड्यूल में प्रवेश करने के लिए ऊपरी दाएं कोने में "स्कैन करें" पर क्लिक करें।',
    'scan_login_a_p3': '3. "एल्बम चयन" पर क्लिक करें और एल्बम की अनुमति दें, सहेजे गए क्यूआर कोड लॉगिन पेज स्क्रीनशॉट का चयन करें, सिस्टम को पहचानने के बाद "लॉगिन" पुष्टि बटन पर क्लिक करें, ब्राउज़र पर वापस जाएं और थोड़ी देर प्रतीक्षा करें, पृष्ठ स्वचालित रूप से उपयोगकर्ता को लोड करेगा जानकारी।',
    'scan_login_b_title': 'QR कोड को स्कैन करके लॉगिन करें',
    'scan_login_b_p1': '1. यह कई उपकरणों के उपयोग के लिए अधिक उपयुक्त है। उपयोगकर्ता रिचार्ज वेबसाइट के लॉगिन पृष्ठ में प्रवेश करता है और "स्कैन कोड लॉगिन" का चयन करने के लिए क्लिक करता है',
    'scan_login_b_p2': '2. किसी अन्य डिवाइस पर BuzzCast APP खोलें, "पर्सनल सेंटर" या "डायनामिक" फ़ंक्शन मॉड्यूल पर जाएं, और कोड स्कैनिंग फ़ंक्शन मॉड्यूल में प्रवेश करने के लिए ऊपरी दाएं कोने में "स्कैन" पर क्लिक करें।',
    'scan_login_b_p3': '3. कोड स्कैनिंग लॉगिन पृष्ठ पर क्यूआर कोड के साथ कोड स्कैनिंग बॉक्स को संरेखित करें, सिस्टम द्वारा इसे पहचानने के बाद "लॉगिन" पुष्टि बटन पर क्लिक करें (कोड को स्कैन करते समय उपकरणों के बीच एक निश्चित दूरी रखने की सिफारिश की जाती है, जो आसान है प्रणाली को पहचानने के लिए)। थोड़ी देर बाद, पृष्ठ स्वचालित रूप से उपयोगकर्ता की जानकारी लोड करेगा।',
    'scan_login_lesson_end': 'उपरोक्त कोड स्कैनिंग के लिए एक ट्यूटोरियल गाइड है, मुझे उम्मीद है कि आप मदद कर सकते हैं। ग्राहक सेवा परामर्श के लिए, कृपया APP संदेश-आधिकारिक समाचार-प्रतिक्रिया और सहायता दर्ज करें।',
    'or': 'या',
    'input_phone_num': 'फ़ोन नंबर खाली नहीं हो सकता',
    'input_email': 'कृपया ईमेल पता इनपुट करें',
    'input_password': 'पासवर्ड डालें',
    'log_in_using_Facebook': 'Facebook के साथ लॉगिन करें',
    'log_in_using_Google': 'Google के साथ साइन इन करें',
    'account_or_pwd_error': 'गलत खाता या पासवर्ड',
    'pay_fail_system_risk': 'लेन-देन विफल: सिस्टम असामान्य',
    'friendly_tip': 'अनुकूल सुझाव',
    'i_got_it': 'मैंने इसे',
    'android_fblogin_tip': 'चूँकि Facebook अब Android एम्बेडेड ब्राउज़र पर प्रमाणीकरण लॉगिन का समर्थन नहीं करता है, इसलिए जब आप इस तरह से लॉग इन करते हैं तो आप लॉग इन नहीं कर पाएंगे। यदि आप इस प्रकार की लॉग-इन समस्या का सामना करते हैं, तो कृपया इसे एक्सेस करने के लिए क्रोम ब्राउज़र का उपयोग करें।',
    'recharge_tip': 'प्राप्त हीरे की विशिष्ट राशि वास्तविक शुल्क राशि के अधीन है।',
    'charge': 'फिर से दाम लगाना',
    'link_add_mainpage': 'अगले पुनः लोड करने के लिए होम स्क्रीन पर एक लिंक जोड़ें',
    'click_me_to_add': 'जोड़ने के लिए मुझे क्लिक करें',
    'user_has_delete': 'उपयोगकर्ता को रद्द कर दिया गया है',
    'support_contant_whatsapp': 'यदि आपको सहायता की आवश्यकता है, तो कृपया {msg} App पर ग्राहक सेवा से संपर्क करें: 1924383',
    'buy_balance': 'क्रय योग्य शेष:',
    'official_coin_seller': 'आधिकारिक सिक्का व्यापारी',
    'paystyle_unavailabel_change_other': 'सिस्टम असामान्य है, यह भुगतान विधि अस्थायी रूप से अनुपलब्ध है, आप अन्य भुगतान विधियों में बदल सकते हैं।',
    'failedPay': 'पैसा एक मुद्दा से मिली, कृपया नया पैसा करें',
    "copied": "कॉपी किया गया",
    "reseller": "पुनर्विक्रेता",
    "netword_busy_try": "नेटवर्क व्यस्त है, कृपया पुनः प्रयास करें",
    "placecommen": 'कृपया अपनी खोज दर्ज करें',
    "app_all_v2": 'इस पूरे महीने',

		"use_phone_login": `फ़ोन से लॉगिन करें`,
    "use_email_login": `ईमेल से लॉगिन करें`,
    "device_is_more": "इस डिवाइस के लिए पंजीकृत खातों की संख्या ऊपरी सीमा तक पहुंच गई है",
    "Operation_failed": "खाता उल्लंघन के कारण यह उपकरण स्थायी रूप से जमे हुए हैं",
    "bondo_pay_tip": "The recharged balance can only be used in the app. Download and open the app to use your balance to unlock and watch paid episodes",
    "bondo_pay_success_tip": "Download Bondo from the App Store and sign in to both the app and the website with the same account. Once completed, any balance topped up on the website can be used in the app to unlock paid short-drama episodes",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/hi.js